//cancellable delay
export const delay = (fn, delay) => {
    let timer = undefined;
    let _reject = undefined;
    const p = new Promise((resolve, reject) => {
        _reject = reject;
        timer = setTimeout(() => {
            //      console.log('delay is calling function');
            const result = fn ? fn() : undefined;
            resolve(result);
        }, delay);
    });
    return Object.assign(p, {
        cancel: () => {
            if (timer !== undefined) {
                clearTimeout(timer);
                timer = 0;
                if (_reject) {
                    _reject();
                }
                _reject = undefined;
            }
        },
    });
};
//cancellable debounce
export const debounce = (fn, delay) => {
    let timeout;
    let _reject = undefined;
    return (...args) => Object.assign(new Promise((resolve, reject) => {
        _reject = reject;
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => resolve(fn(...args)), delay);
    }), {
        cancel: () => {
            if (timeout !== undefined) {
                clearTimeout(timeout);
                timeout = undefined;
                if (_reject) {
                    _reject();
                }
                _reject = undefined;
            }
        },
    });
};
//cancellable throttle
export const throttle = (fn, limit) => {
    let timeout;
    let _resolve = undefined;
    let _reject = undefined;
    let callFn = undefined;
    //  let _args: Parameters<F> | undefined;
    const onTimeout = () => {
        timeout = undefined;
        if (callFn) {
            const lastResult = callFn();
            callFn = undefined;
            if (_resolve) {
                _resolve(lastResult);
            }
            _resolve = undefined;
            //start a new timer
            timeout = setTimeout(onTimeout, limit);
        }
        else {
            timeout = undefined;
        }
    };
    return (...args) => {
        callFn = () => fn(...args);
        const p = new Promise((resolve, reject) => {
            _resolve = resolve;
            _reject = reject;
        });
        if (!timeout) {
            timeout = setTimeout(onTimeout, limit);
            const lastResult = callFn();
            callFn = undefined;
            if (_resolve) {
                _resolve(lastResult);
            }
            _resolve = undefined;
        }
        return Object.assign(p, {
            cancel: () => {
                if (timeout !== undefined) {
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (_reject) {
                        _reject();
                    }
                    _reject = undefined;
                }
            },
        });
    };
};
